import React, { useState, useEffect } from "react";
import "./Images.css";
import "./Parallax.js";

// Import all your assets
import Ginger_Cat from "./Artwork/Ginger_Cat.png";
import Gray_Cat from "./Artwork/Gray_Cat.png";
import L_Paint from "./Artwork/L_Paint.png";
import L_Paintbrush from "./Artwork/L_Paintbrush.png";
import lily from "./Artwork/lily.png";
import pink_code from "./Artwork/pink_code.png";
import pink_star from "./Artwork/pink_star.png";
import saturn from "./Artwork/saturn.png";
import shrimp from "./Artwork/shrimp.png";
import tulip from "./Artwork/tulip.png";
import yellow_star from "./Artwork/yellow_star.png";
import blue_star from "./Artwork/blue_star.png";
import blue_controller from "./Artwork/blue_controller.png";

const Parallax_Images = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!isDesktop) return null;

  return (
    <div className="parallax-container">
     <img src={Ginger_Cat} alt="" className="parallax parallax-image ginger-cat" data-speed="3.85" />
<img src={blue_star} alt="" className="parallax parallax-image blue-star" data-speed="1.55" />
<img src={L_Paint} alt="" className="parallax parallax-image l-paint" data-speed="2.70" />
<img src={L_Paintbrush} alt="" className="parallax parallax-image l-paintbrush" data-speed="3.90" />
<img src={blue_controller} alt="" className="parallax parallax-image blue-controller" data-speed="1.75" />
<img src={tulip} alt="" className="parallax parallax-image tulip" data-speed="2.50" />
<img src={Gray_Cat} alt="" className="parallax parallax-image gray-cat" data-speed="3.80" />
<img src={lily} alt="" className="parallax parallax-image lily" data-speed="1.25" />
<img src={shrimp} alt="" className="parallax parallax-image shrimp" data-speed="2.65" />
<img src={yellow_star} alt="" className="parallax parallax-image yellow-star" data-speed="1.20" />
<img src={pink_code} alt="" className="parallax parallax-image pink-code" data-speed="3.48" />
<img src={saturn} alt="" className="parallax parallax-image saturn" data-speed="2.40" />
<img src={pink_star} alt="" className="parallax parallax-image pink-star" data-speed="1.52" />



    </div>
  );
};

export default Parallax_Images;
